export const courseItemType = {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    MICROCAST: 'MICROCAST',
    ARTICLE: 'ARTICLE',
    PDF: 'PDF',
    BLOCK: 'BLOCK',
    QUIZ: 'QUIZ',
    DOWNLOAD: 'DOWNLOAD',
    KNOWLEDGECHECK: 'KNOWLEDGECHECK',
    CERTIFICATION: 'CERTIFICATION',
    TYPEFORM: 'TYPEFORM',
    SCORM: 'SCORM',
    HTML: 'HTML',
};
export const courseItemStatus = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    SKIPPED: 'SKIPPED',
};
export const infoTabs = {
    overview: { value: 0, label: 'Overview' },
    material: { value: 1, label: 'Course Materials' },
    transcript: { value: 2, label: 'Transcript' },
};
//# sourceMappingURL=constants.js.map